var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCylinder20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 557",
    d: "M5.66991 8.29592L1.33972 5.44922V15.2723L2.30199 17.2771L5.91048 18.8006L10.4411 19.5624L15.1723 18.8006L18.4199 15.9539V5.44922L14.6109 8.29592L10.2006 8.81714L5.66991 8.29592Z",
    fill: "#95E3FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 556",
    d: "M2.96867 2.75076L1.92395 4.20703C1.83188 4.33537 1.79182 4.49381 1.81182 4.65049L1.98128 5.97792C2.00642 6.17488 2.12366 6.34818 2.29714 6.44479L5.09004 8.00033C5.1553 8.03668 5.22654 8.06103 5.3004 8.07224L10.8856 8.91965C10.9628 8.93136 11.0415 8.9285 11.1176 8.91123L15.6165 7.89047C15.7196 7.86709 15.815 7.81796 15.8939 7.74769L18.0344 5.84131C18.2198 5.67616 18.2899 5.4169 18.2129 5.18082L17.81 3.94518C17.7637 3.80318 17.6681 3.68245 17.5404 3.60487L13.7982 1.33018C13.7004 1.27071 13.5881 1.23926 13.4736 1.23926H8.63139C8.58174 1.23926 8.53226 1.24517 8.48401 1.25688L3.32913 2.5077C3.18376 2.54297 3.05586 2.62921 2.96867 2.75076Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 72",
    d: "M18.46 15.0367C18.46 17.3522 14.6724 19.2293 10.0001 19.2293C5.32785 19.2293 1.54022 17.3522 1.54022 15.0367",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 74",
    d: "M18.4364 4.69369C18.4364 5.56653 17.7053 6.52825 16.1298 7.309C14.5934 8.07042 12.427 8.55926 10 8.55926C7.57305 8.55926 5.40669 8.07042 3.87024 7.309C2.29482 6.52825 1.56372 5.56653 1.56372 4.69369C1.56372 3.82085 2.29482 2.85913 3.87024 2.07839C5.40669 1.31696 7.57305 0.828125 10 0.828125C12.427 0.828125 14.5934 1.31696 16.1298 2.07839C17.7053 2.85913 18.4364 3.82085 18.4364 4.69369Z",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 312",
    d: "M1.54022 4.85535V15.1985",
    stroke: "#222627",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 313",
    d: "M18.4601 4.6936V15.0367",
    stroke: "#222627",
    strokeWidth: 1.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylinder20);
export default __webpack_public_path__ + "static/media/cylinder_20.c57e4af127dfebcd9b4619228faf9a5e.svg";
export { ForwardRef as ReactComponent };